import { faArrowsRotate, faCopy } from '@fortawesome/pro-light-svg-icons'
import PermissionChecker from '../../../../../../../../../baseComponents/PermissionChecker'
import { TwinIconToolTip } from '../../../../../../../../../baseComponents/TwinIcon'
import { OrderData } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useEditDeleteModal from '../../../../../../../../../utils/hooks/useEditDeleteModal'
import { getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import ModalSellDeliveryNoteDuplicate from './ModalSellDeliveryNDuplicate'
import ModalRecalculateSellDeliveryNote from './ModalRecalculateSellDeliveryNote'

interface SellDeliveryNoteDuplicateButtonProps {
    allRowData: OrderData
    title: string
    id: string
    children?: React.ReactNode
}

export const SellDeliveryNoteDuplicateButton: React.FC<SellDeliveryNoteDuplicateButtonProps> = ({ allRowData, id, title, children }) => {
    const { openModal, setOpenModal } = useSellDeliveryNoteDuplicateButtonLogic()
    return (
        <PermissionChecker permission='create' userPermissions={getUserPermissions('sell.deliveryNote')}>
            <div onClick={() => setOpenModal({ type: 'create', allRowData })}>
                { children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faCopy} id={id} /> }
            </div>
            {openModal?.type === 'create' ? <ModalSellDeliveryNoteDuplicate setOpened={() => setOpenModal({ type: 'delete', allRowData })} allRowData={allRowData} onSubmit={() => { }} /> : null}
        </PermissionChecker>
    )
}

const useSellDeliveryNoteDuplicateButtonLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()

    return { openModal, setOpenModal }
}

interface SellDeliveryNoteRecalculateButtonProps {
    allRowData: OrderData
    onSubmit?: () => void
    title: string
    id: string
    children?: React.ReactNode
}

export const SellDeliveryNoteRecalculateButton: React.FC<SellDeliveryNoteRecalculateButtonProps> = ({ allRowData, onSubmit, id, title, children }) => {
    const { openModal, setOpenModal } = useSellDeliveryNoteRecalculateButtonLogic()
    return (
        <PermissionChecker permission='update' userPermissions={getUserPermissions('sell.deliveryNote')}>
            <div onClick={() => setOpenModal({ type: 'create', allRowData })}>
                {children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faArrowsRotate} id={id} />}
            </div>
            {openModal?.type === 'create' ? <ModalRecalculateSellDeliveryNote setOpened={() => setOpenModal({ type: 'delete', allRowData })} allRowData={allRowData} onSubmit={() => onSubmit?.()} /> : null}
        </PermissionChecker>
    )
}

const useSellDeliveryNoteRecalculateButtonLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()

    return { openModal, setOpenModal }
}